import React, { Component, Fragment } from 'react';
import {Helmet} from "react-helmet";
import Breadcrumb from "../../../common/breadcrumb";
import {clear_auth, set_auth} from "../../../../reducers/Auth";
import {connect} from "react-redux";
import {Empty, Spin, Tooltip} from "antd";
import {pageNumber} from "../../../../functions/functionGeneral";
import Paging from "../../../paging";
import PlusIcon from "../../../../assets/icons/plus-white.svg";
import Add from "./add";
import Edit from "./edit";
import Swal from "sweetalert2";
import refreshIcon from "../../../../assets/icons/refresh.svg";
import { PERMISSIONS } from "../../../../helper/permissionHelper";
import { withPageAccess } from "../../../common/ProtectedPage";
import {TourContext} from "../../../guideComponent/guideTourProvicer";

class FinanceTerm extends Component {
  static contextType = TourContext;
  constructor(props) {
    super(props);
    this.state = {
      data : [],
      currentPage : 0,
    }
  }

  loadData() {
    this.setState({loading: true})
    let form = {
      keyword     : this.state.keyword,
      type        : this.state.type,
      paginate    : 10,
      page        : this.state.currentPage + 1,
    }
    this.props.request("finance_term/list", form, 'POST')
      .then(response => {
        if (response && response.success) {
          this.setState({
            data: response.data.data,
            loading: false,
            totalData: response.data.total,
            pageCount: response.data.last_page,
            perPage: response.data.per_page,
          })
        }
      });
  }

  handleChange = (event) => {
    const value = event.target.value;
    const name = event.target.name;

    this.setState({
      currentPage: 0,
      [name]: value
    })
  }

  handleDelete() {
    Swal.fire({
      title: 'Pemberitahuan!',
      text: 'Anda yakin ingin menghapus?',
      icon: 'warning',
      confirmButtonText: 'Ya',
      showCancelButton: true,
      cancelButtonText: 'Batal',
    })
      .then((result) => {
        if (result.isConfirmed) {
          let form = {
            fin_term_id    : this.state.fin_term_id
          }
          this.props.request("finance_term/delete", form, 'POST')
            .then(response => {
              if (response && response.success) {
                Swal.fire({
                  title: 'Berhasil!',
                  text: response.message,
                  icon: 'success',
                  showConfirmButton: false,
                  timer: 800,
                })
                this.loadData()
              }
            });
        }
      })
  }

  handlePageClick = (data) => {
    let selected = data.selected
    this.setState({ currentPage: selected }, () => {
      this.loadData()
    });
  }

  componentDidMount() {
    this.loadData()
  }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.loading === true && this.state.loading === false) {
            this.tourTimeout = setTimeout(() => {
                const tourSteps = [
                    {
                        selector: '.fltr-nama',
                        title: 'Cari Term',
                        content: 'Gunakan kolom pencarian ini untuk mencari data term berdasarkan nama. Tekan Enter untuk memulai pencarian.'
                    },
                    {
                        selector: '.select-column',
                        title: 'Filter Tipe',
                        content: 'Gunakan dropdown ini untuk memfilter data berdasarkan tipe term, yaitu Income atau Outcome.'
                    },
                    {
                        selector: '.button-reset',
                        title: 'Reset Filter',
                        content: 'Klik tombol ini untuk mengembalikan seluruh filter ke pengaturan awal dan memuat ulang data.'
                    }
                ];

                if (this.props.user.user_level.level_action_limited == null || this.props.user.user_level.level_action_limited.search("C") >= 0) {
                    tourSteps.push({
                        selector: '.btn-primary.width-filter',
                        title: 'Tambah Term',
                        content: 'Klik tombol ini untuk menambahkan data term baru.'
                    });
                }

                if ((this.props.user.user_level.level_action_limited == null || this.props.user.user_level.level_action_limited.search("R") >= 0) && !this.state.loading) {
                    if (this.state.data.length === 0) {
                        tourSteps.push({
                            selector: '.table-responsive',
                            title: 'Daftar Term (Kosong)',
                            content: 'Belum ada data term yang tersedia. Gunakan pencarian atau ubah filter untuk melihat data.'
                        });
                    } else {
                        tourSteps.push(
                            {
                                selector: '.table-responsive',
                                title: 'Daftar Term',
                                content: `Tabel ini menampilkan ${this.state.data.length} data term yang tersedia di sistem.`
                            },
                        );
                    }
                }

                if (
                    !this.state.loading &&
                    this.state.data.length > 0 &&
                    (this.props.user.user_level.level_action_limited == null ||
                        this.props.user.user_level.level_action_limited.search("U") >= 0 ||
                        this.props.user.user_level.level_action_limited.search("D") >= 0)
                ) {
                    tourSteps.push({
                        selector: '.fa-ellipsis-v',
                        title: 'Edit & Hapus',
                        content: 'Dari menu aksi ini Anda dapat mengedit atau menghapus data term yang sudah ada.'
                    });
                }

                const { setSteps, setCurrent, setActive } = this.context;
                setSteps(tourSteps);
                setCurrent(0);
                setActive(true);
            }, 500);
        }
    }

    componentWillUnmount() {
        clearTimeout(this.tourTimeout);
    }

  render() {
    let no = 0;
      return (
        <Fragment>
          <Helmet>
            <meta charSet="utf-8" />
            <title>Daftar Istilah Keuangan - Presensi</title>
            <meta name="description" content="Daftar Istilah Keuangan" />
          </Helmet>
          <Breadcrumb parent="Settings" title="Daftar Istilah Keuangan"/>
          <Add
            handleChange={this.handleChange}
            modal_add={this.state.modal_add}
            request={(action, data, method = 'GET') => this.props.request(action, data, method)}
            changeState={(state, callback) => {
              this.setState(state, () => {
                if (typeof callback != 'undefined')
                  callback()
              })
            }}
            loadData={() => this.loadData()}
          />
          <Edit
            handleChange={this.handleChange}
            modal_edit={this.state.modal_edit}
            data={this.state}
            request={(action, data, method = 'GET') => this.props.request(action, data, method)}
            changeState={(state, callback) => {
              this.setState(state, () => {
                if (typeof callback != 'undefined')
                  callback()
              })
            }}
            loadData={() => this.loadData()}
          />
          <div className="container-fluid">
            <div className="card">
              <div className="card-header">
                <div className="row">
                  <div className="col-md-4 d-flex pr-md-1">
                    <input
                      type='text' onChange={this.handleChange}
                      name='keyword' value={this.state.keyword}
                      className="form-control fltr-nama mb-2"
                      placeholder="&#xF002;  Cari"
                      onKeyUp={(e) => {
                        if (e.key === "Enter") {
                          this.loadData()
                        }
                      }}
                    />
                  </div>
                  <div className="col-md-3 px-md-1 d-flex flex-row flex-nowrap mb-2">
                    <select
                      className="form-control input-select-style select-column w-100 mr-2 mt-0"
                      onChange={(e)=> this.setState({type: e.target.value}, this.loadData)}
                      style={{marginLeft: "0"}}
                    >
                      <option value="" selected={this.state.type === ''}>Pilih Tipe</option>
                      <option value="income">Income</option>
                      <option value="outcome">Outcome</option>
                    </select>
                    <div>
                      <button className="input-select-style button-reset mt-0"
                              style={{width: "44px"}} onClick={() => {
                        this.setState({
                          keyword: "",
                          type: ""
                        }, () => this.loadData())
                      }}>
                        <img src={refreshIcon} alt=""/>
                      </button>
                    </div>
                  </div>
                  <div className="col-md-5 justify-content-end">
                    {(this.props.user.user_level.level_action_limited == null || this.props.user.user_level.level_action_limited.search("C") >= 0) && (
                      <button
                        className="btn btn-primary text-capitalize width-filter pull-right"
                        onClick={() => {
                          this.setState({modal_add: true});
                        }}
                      >
                        <img src={PlusIcon} alt=""/> Tambah Term
                      </button>
                    )}
                  </div>
                </div>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="table-responsive">
                      {!this.state.loading && this.state.data.length === 0 ?
                        <Empty description="Data Kosong"
                               image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"/>
                        :
                        <div>
                          {(this.props.user.user_level.level_action_limited == null || this.props.user.user_level.level_action_limited.search("R") >= 0) && (
                            <table className="table mb-5 table-striped table-borderless">
                              <thead>
                              <tr>
                                <th className='lembur-th-style text-center' width="50">#</th>
                                <th className='lembur-th-style'>Tipe</th>
                                <th className='lembur-th-style'>Nama</th>
                                <th className='lembur-th-style text-center'>Aksi</th>
                              </tr>
                              </thead>
                              <tbody>
                              {this.state.loading ?
                                <tr>
                                  <td colSpan="9" style={{
                                    textAlign: "center",
                                    backgroundColor: "#FFFFFF"
                                  }}>
                                    <Spin size="large"
                                          tip="Sedang Memuat Data"
                                          style={{
                                            width: '100%',
                                            margin: 'auto',
                                            marginBottom: '10px',
                                            marginTop: '10px'
                                          }}/>
                                  </td>
                                </tr>
                                :
                                this.state.data.map((item, index) => {
                                  no += 1
                                  return (
                                    <tr key={index}>
                                      <td
                                        className="lembur-td-style text-center">{pageNumber(no, this.state.perPage, this.state.currentPage)}</td>
                                      <td className="lembur-td-style">{item.fin_term_type}</td>
                                      <td className="lembur-td-style">{item.fin_term_name}</td>
                                      <td className="lembur-td-style text-center">
                                        <Tooltip trigger={'click'} zIndex={1} placement="bottom" color={'#fff'} title={
                                          <div className={'text-dark'}>
                                            {(this.props.user.user_level.level_action_limited == null || this.props.user.user_level.level_action_limited.search("U") >= 0) && (
                                              <a onClick={() => {
                                                this.setState({
                                                  fin_term_id: item.fin_term_id,
                                                  fin_term_name: item.fin_term_name,
                                                  fin_term_type: item.fin_term_type,
                                                  modal_edit: true
                                                })
                                              }}>Edit</a>
                                            )}
                                            <br/>
                                            {(this.props.user.user_level.level_action_limited == null || this.props.user.user_level.level_action_limited.search("D") >= 0) && (
                                              <a onClick={() => {
                                                this.setState({
                                                  fin_term_id: item.fin_term_id
                                                })
                                                this.handleDelete()
                                              }} className={'text-danger'}>Hapus</a>
                                            )}
                                          </div>
                                        }>
                                          <a><i
                                            className="fa fa-ellipsis-v"
                                            style={{
                                              width: 35,
                                              fontSize: 18,
                                              padding: 11,
                                              color: 'rgb(51 51 51)'
                                            }}
                                          ></i></a>
                                        </Tooltip>
                                      </td>
                                    </tr>
                                  )
                                })}
                              </tbody>
                            </table>
                          )}
                        </div>
                      }
                    </div>
                    <div className="row">
                      <div className='col font-14 fw-500 m-auto'>
                        Menampilkan {this.state.data.length === 0 || this.state.data.length === null ? "0" : this.state.data.length} dari {this.state.totalData} Data.
                      </div>
                      <div className="col">
                        <Paging
                          className="float-right"
                          handlePageClick={this.handlePageClick}
                          pageCount={this.state.pageCount}
                          currentPage={this.state.currentPage}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Fragment>
      );
  }
}

const mapStateToProps = state => ({
  user: state.Auth.user,
  api_token: state.Auth.api_token
});

const mapDispatchToProps = dispatch => ({
  clear_auth: () => dispatch(clear_auth()),
  set_auth: (api_token, data) => dispatch(set_auth(api_token, data))
})

export default connect(mapStateToProps, mapDispatchToProps)(withPageAccess(FinanceTerm, PERMISSIONS.KEUANGAN));